export * from './lib/icon.component.module';
